<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>shopping_bag</md-icon>
          </div>
          <h4 class="title">Create New Product</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="name" type="text" required ></md-input>
          </md-field>
          <md-field>
            <label>Slug</label>
            <md-input v-model="slug" type="text" required ></md-input>
          </md-field>
          <md-field>
            <label>Description</label>
            <md-input v-model="shortDescription" type="text" required></md-input>
          </md-field>
          <md-field>
            <label>Price</label>
            <md-input v-model="price" type="number" required></md-input>
          </md-field>
          <md-field>
            <label>Offer Price</label>
            <md-input v-model="offerPrice" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Offer Price Text</label>
            <md-input v-model="offerPriceText" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Categories</label>
            <md-select v-model="selectedCategories" multiple placeholder="Select categories">
                <md-option
                v-for="category in categories"
                :key="category._id"
                :value="category._id"
                >
                {{ category.title }}
                </md-option>
            </md-select>
        </md-field>
          <md-field>
            <input type="file" @change="fileUpload( $event )"  /> 
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isDisabled" @click="createProduct()">
            Create <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import ProductService from "../../../services/ProductService";
import CategoryService from "../../../services/CategoryService";
export default {
  components: {},
  data() {
    return {
      isDisabled: false,
      name: "",
      slug: "",
      shortDescription:"",
      price: 0,
      offerPrice:"",
      offerPriceText:"",
      productImage:"",
      categories: [],
      selectedCategories: [] // 👈 holds selected category IDs
    };
  },
  methods: {
    fileUpload(event){
      this.productImage = event.target.files[0];
    },
    async createProduct() {
      this.isDisabled = true;
      let formData = new FormData();
      formData.append("productImage", this.productImage);
      formData.append("name", this.name);
      formData.append("slug", this.slug);
      formData.append("shortDescription", this.shortDescription);
      formData.append("price", this.price);
      formData.append("offerPrice", this.offerPrice);
      formData.append("offerPriceText", this.offerPriceText);
      // 👇 Add selected categories
      this.selectedCategories.forEach((catId) => {
        formData.append("categories[]", catId);
      });

      await ProductService.createProduct(formData)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('products');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    getCategories() {
      CategoryService.getCategories()
        .then((response) => {
            this.categories = response.data.data;
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  watch: {
    name(newName) {
      // Generate slug from title
      this.slug = newName
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '') // remove invalid chars
        .replace(/\s+/g, '-')         // replace spaces with -
        .replace(/-+/g, '-');         // collapse multiple -
    }
  },
  beforeMount() {
    this.getCategories()
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
